import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Modal } from 'flowbite';
import moment from 'moment';
import { IBase, IRouteSetup, IRouteSetupDayOfWeek, IRouteSetupDetail, IRouteSetupHolyDay, IServiceInfo, IServiceWizardSetupPayload, IVehicle } from 'src/app/models';
import { NotificationTypes, ServiceType, ServiceWizardStep, TicketingType, UserRole, UserSortType, UserStatus } from 'src/app/models/enums';
import { APP } from 'src/app/config/app';
import { LiteralService, RouteService, ServiceWizardService, StorageService, UsersService, UtilsService, VehiclesService } from 'src/app/services';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { initialRouteSetupDetailCreate } from 'src/app/store/initialisation/setup';
import { ModalEditScheduleComponent } from 'src/app/shared/modals/modal-edit-schedule/modal-edit-schedule.component';
import { ModalRouteDeparturesComponent } from 'src/app/shared/modals/modal-route-departures/modal-route-departures.component';
import { images } from 'src/images';
import { buildQueryString } from 'src/app/filters';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrl: './setup.component.scss',
  standalone: false
})
export class SetupComponent implements OnInit, OnDestroy {

  public routeId: any;
  public serviceInfoId: number | undefined;
  public serviceName: string = '';
  public routeName: string = '';
  public ticketingType: TicketingType | undefined;
  public roundTrips: boolean = false;
  public setups: IRouteSetup[] = [];
  public setupDetail: IRouteSetupDetail;
  public selectedSetup: number = 0;
  public showDetails = false;
  public newSetup = false;
  public wizardMode = false;
  public wizardBackwards = false;
  public showAvailabilitiesView = false;
  // Starts as loading so no empty state flashes before the first setups fetch resolves
  public loadingSetupDetail = true;
  private lastLoadedRouteId: number | null = null;
  private navigationSubscription?: Subscription;
  public newSetupObject = initialRouteSetupDetailCreate();
  
  public setupData: any = [];
  
  public editSetup = false;

  public images = images;
  public Object = Object;
  public moment = moment;
  public TooltipPosition = TooltipPosition;
  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  public daysOfWeek: Record<string, any[]> = {
    MONDAY: [],
    TUESDAY: [],
    WEDNESDAY: [],
    THURSDAY: [],
    FRIDAY: [],
    SATURDAY: [],
    SUNDAY: [],
  };
  public daysOfWeekCopy: any;
  public differences: any;
  
  public holyDays: Record<string, any[]> = {
    EVE: [],
    BANK: [],
  };
  public holyDaysCopy: any;

  public holidayCalendars: IBase[] = [];

  public drivers: Record<string, string> = { };
  public driversClientId?: number;
  public vehicles: Record<string, string> = { };


  public colors = [
    '#D1FAEC',
    '#E5D6F5',
    '#D1E2FA',
    '#D1F5FA',
    '#F8D1FA',
    '#CBC9F7',
    '#D6F5DD',
    '#F8BFE1',
    '#D3F9C8',
    '#F8BFC7',
    '#E8F8C3',
    '#F8F1C3',
    '#F8D3C3',
  ];

  public changeStatusModal: Modal;
  public changeStatusShowed: boolean = false;
  public changingStatus = false;
  public changeStatusSelected = true;
  public changeStatusIdSelected: number;

  @ViewChild(ModalEditScheduleComponent) editScheduleComponent: ModalEditScheduleComponent;
  public editScheduleModal: Modal;
  public editScheduleShowed: boolean = false;

  public createScheduleModal: Modal;
  public createScheduleShowed: boolean = false;

  public duplicateSetupModal: Modal;
  public duplicateSetupShowed: boolean = false;

  public departuresModal: Modal;
  public departuresShowed: boolean = false;
  public creatingQuickService = false;
  public creationPercentage = 0;
  public creationDetail = '';
  public wizardDepartures: any[] = [];
  @ViewChild(ModalRouteDeparturesComponent) departuresModalComponent: ModalRouteDeparturesComponent;
  private wizardBackSubscription?: Subscription;
  private wizardContinueSubscription?: Subscription;
  private wizardDataSubscription?: Subscription;

  public deleteSchedulesModal: Modal;
  public deleteSchedulesShowed: boolean = false;
  public deletingSchedules: boolean = false;

  public confirmSetupUpdateModal: Modal;
  public confirmSetupUpdateShowed: boolean = false;
  public updatingSetup: boolean = false;
  public hasScheduleUpdates: boolean = false;
  public hasScheduleDeletes: boolean = false;
  public hasDateChanges: boolean = false;
  public pendingUpdateData: any = null;
  public originalSetupDates: { fromDate: any; toDate: any; creationAdvancedDays: any } | null = null;

  public changesDetected = false;

  public userRole: UserRole;
  public serviceType: ServiceType | undefined;
  public backingIdPlaceholder: string = '';
  public backUrl: string = '/services';

  public floatingButton = 'plus';
  public floatingButtonOptions: any[] = [];
  public multiselectEnabled = false;

  public weekDaysChecked: any[] = [];

  public availableRoutes: any[] = [];

  public days = [ 
    { id: 'MONDAY', name: 'calendar.longWeekDays.mon' },
    { id: 'TUESDAY', name: 'calendar.longWeekDays.tue' },
    { id: 'WEDNESDAY', name: 'calendar.longWeekDays.wed' },
    { id: 'THURSDAY', name: 'calendar.longWeekDays.thu' },
    { id: 'FRIDAY', name: 'calendar.longWeekDays.fri' },
    { id: 'SATURDAY', name: 'calendar.longWeekDays.sat' },
    { id: 'SUNDAY', name: 'calendar.longWeekDays.sun' },
    { id: 'EVE', name: 'calendar.longWeekDays.eve' },
    { id: 'BANK', name: 'calendar.longWeekDays.bank' },
  ];

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    if (this.changesDetected) {
      confirm();
      event.preventDefault();
    }
  }

  constructor(
              public literalService: LiteralService,
              private routeService: RouteService,
              private storageService: StorageService,
              public utilsService: UtilsService,
              private usersService: UsersService,
              private vehiclesService: VehiclesService,
              private serviceInfoService: ServiceInfoService,
              public serviceWizardService: ServiceWizardService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {}

  async ngOnInit() {
    this.literalService.setTitle('sidebar.services', ' - NEMI Backoffice');
    this.storageService.setBreadcrumbLoading();
    this.syncAvailabilitiesViewFromUrl();
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.syncAvailabilitiesViewFromUrl();
        this.syncSelectedSetupFromUrl();
      }
    });
    this.userRole = await this.storageService.getRole();
    this.activatedRoute.queryParamMap.subscribe(async (params) => {
      this.routeId = this.pathRouteId ?? params.get('routeId');
      // Wizard completion mode: the setup was just created through quick-creation, so only
      // the detail view is offered and the generated date range is highlighted
      this.wizardMode = this.activatedRoute.snapshot.data['wizard'] === true;
      if (this.wizardMode) {
        this.wizardBackwards = this.activatedRoute.snapshot.data['backwards'] === true;
        this.activateWizardSetupStep();
        // The component is reused between the forward and backwards setup URLs (see
        // CustomRouteReuseStrategy), so step changes arrive through the route data
        this.wizardDataSubscription ??= this.activatedRoute.data.subscribe((data) => this.onWizardSetupRouteData(data));
      }
      if (!this.routeId) {
        // Wizard setup step: nothing is created yet. A default setup is preloaded as the
        // editable background; discretionary services define departures through their modal
        // and the rest create days of week. Either path drives the final quick-creation call.
        if (this.wizardMode) await this.initializeWizardDefaultSetup();
        this.loadingSetupDetail = false;
        return;
      }
      // Query params also change for embedded-availabilities pagination and filters:
      // the setup data only reloads when the route itself changes
      if (Number(this.routeId) === this.lastLoadedRouteId) return;
      this.lastLoadedRouteId = Number(this.routeId);
      this.loadingSetupDetail = true;
      try {
      // Fetch route details to get the serviceInfoId for back navigation
      const routeDetails: any = await this.routeService.getService(Number(this.routeId));
      this.serviceInfoId = routeDetails?.serviceId;
      this.routeName = routeDetails?.name || '';
      this.ticketingType = routeDetails?.ticketingType;

      // Fetch service info to get the service name for breadcrumb
      if (this.serviceInfoId) {
        const serviceInfo: any = await this.serviceInfoService.getServiceInfo(this.serviceInfoId);
        this.serviceName = serviceInfo?.name || '';
        this.roundTrips = serviceInfo?.roundTrips ?? false;
        this.serviceType = serviceInfo?.serviceType;
        this.updateBreadcrumb();
      }
      const res: any[] = await this.routeService.getRelateds(this.routeId);
      res.forEach((route: any) => {
        this.availableRoutes.push({id: route.id, value: route.id, label: route.name});
      });
      await this.loadSetups(Number(this.routeId));
      if (this.setups.length > 0) {
        const pathSetupIndex = this.pathSetupId != null ? this.setups.findIndex((setup) => setup.id === this.pathSetupId) : -1;
        if (pathSetupIndex >= 0) this.selectedSetup = pathSetupIndex;
        // Discretionary services have no days of week: their setup opens on the availabilities view
        const forceAvailabilitiesView = this.serviceType === ServiceType.DISCRETIONARY && !this.showAvailabilitiesView;
        if (this.usesPathStyleUrl && (this.pathSetupId == null || forceAvailabilitiesView)) {
          this.reflectSelectedSetupInUrl(this.showAvailabilitiesView || forceAvailabilitiesView, true);
        }
        this.setupDetail = await this.routeService.getRouteSetupsSchedule(Number(this.routeId), this.setups[this.selectedSetup].id!);
        // Store original dates for comparison
        this.storeOriginalDates();
        // Add current route to available routes if not already present
        const currentRouteExists = this.availableRoutes.some(r => r.id === this.setupDetail.route.id);
        if (!currentRouteExists) {
          this.availableRoutes.unshift({id: this.setupDetail.route.id, value: this.setupDetail.route.id, label: this.setupDetail.route.name});
        }
        this.newSetupObject = initialRouteSetupDetailCreate(this.setupDetail);
        this.getData();
      } else {
        this.newSetupObject.route = { id: Number(this.routeId), name: this.routeName };
      }
      } finally {
        this.loadingSetupDetail = false;
      }
    });
    this.floatingButton = 'plus';
    this.floatingButtonOptions = [];
    //this.floatingButtonOptions.push({img: images.setup.export, alt: 'importExport', text: 'setup.importExport', action: undefined});
    this.floatingButtonOptions.push({img: images.setup.multicheck, alt: 'multiselect', text: 'setup.multiselect', action: () => this.enableMultiselect()});
    this.floatingButtonOptions.push({img: images.setup.addAvailabilities, alt: 'addAvailabilities', text: 'setup.addAvailabilities', action: () => this.createSchedule()});
  }

  async refreshSetupsData() {
    const selectedSetupId = this.setups[this.selectedSetup].id;
    await this.loadSetups(Number(this.routeId));
    this.selectedSetup = this.setups.findIndex(s => s.id == selectedSetupId);
  }

  private async loadSetups(routeId: number) {
    const setups = await this.routeService.getRouteSetups(routeId) as IRouteSetup[];
    this.setups = setups.sort((a: IRouteSetup, b: IRouteSetup) =>
      Number(b.active) - Number(a.active) || (a.name ?? '').localeCompare(b.name ?? ''));
    this.setupData = this.setups.map((setup: IRouteSetup) => ({
      id: setup.id?.toString(),
      value: setup,
      label: setup.name!,
      img: setup.active ? images.setup.enabled : images.setup.disabled,
      alt: setup.active ? 'enabled' : 'disabled'
    }));
  }

  async resetSetupData() {
    if (this.isWizardPendingCreation) {
      this.setupDetail.daysOfWeek = [];
      this.setupDetail.holyDays = [];
      this.daysOfWeek = Object.fromEntries(Object.keys(this.daysOfWeek).map((day) => [day, []]));
      this.holyDays = Object.fromEntries(Object.keys(this.holyDays).map((day) => [day, []]));
      this.daysOfWeekCopy = structuredClone(this.daysOfWeek);
      this.holyDaysCopy = structuredClone(this.holyDays);
      this.changesDetected = false;
      return;
    }
    this.setupDetail = await this.routeService.getRouteSetupsSchedule(Number(this.routeId), this.setups[this.selectedSetup].id!);
    await this.getData();
    this.checkChanges();
  }

  ngOnDestroy(): void {
    this.storePendingWizardSetup();
    this.departuresModal?.hide();
    this.createScheduleModal?.hide();
    this.wizardBackSubscription?.unsubscribe();
    this.wizardContinueSubscription?.unsubscribe();
    this.wizardDataSubscription?.unsubscribe();
    this.navigationSubscription?.unsubscribe();
    this.storageService.clearBreadcrumb();
    this.serviceWizardService.stop();
  }

  get isWizardDiscretionary(): boolean {
    return this.serviceWizardService.pendingQuickCreation?.serviceInfo?.serviceType === ServiceType.DISCRETIONARY;
  }

  get isWizardPendingCreation(): boolean {
    return this.wizardMode && !this.routeId;
  }

  get isSetupScheduleEmpty(): boolean {
    return (this.setupDetail?.daysOfWeek?.length ?? 0) === 0 && (this.setupDetail?.holyDays?.length ?? 0) === 0;
  }

  private isWizardContinueReady(): boolean {
    return !this.creatingQuickService;
  }

  private onWizardContinue() {
    if (!this.isWizardPendingCreation) {
      // Everything is created: finishing the wizard returns to the services list
      this.serviceWizardService.stop();
      this.router.navigate(['/services']);
      return;
    }
    this.commitWizardSetupStep();
  }

  private onWizardBack() {
    if (!this.isWizardPendingCreation) return;
    if (this.wizardBackwards) {
      this.router.navigate(['/services', 'new', 'setup']);
    } else {
      this.router.navigate(['/services', 'new', this.serviceWizardService.roundTrip ? 'backwards-route' : 'route']);
    }
  }

  // On the forward setup of a round trip, saving is deferred to the backwards setup step
  private get hasWizardBackwardsSetupStep(): boolean {
    return this.isWizardPendingCreation && this.serviceWizardService.roundTrip && !this.wizardBackwards;
  }

  private commitWizardSetupStep() {
    if (this.hasWizardBackwardsSetupStep) {
      this.router.navigate(['/services', 'new', 'setup', 'backwards']);
      return;
    }
    this.submitWizardSetupCreation();
  }

  private activateWizardSetupStep() {
    this.serviceWizardService.active = true;
    if (this.isWizardPendingCreation) {
      this.serviceWizardService.roundTrip = !!this.serviceWizardService.pendingQuickCreation?.serviceInfo?.roundTrips;
    }
    this.serviceWizardService.setStep(this.wizardBackwards ? ServiceWizardStep.BACKWARDS_SETUP : ServiceWizardStep.FORWARD_SETUP);
    this.serviceWizardService.canContinueEvaluator = () => this.isWizardContinueReady();
    this.serviceWizardService.continueLabelKey = this.isWizardPendingCreation && !this.hasWizardBackwardsSetupStep ? 'save' : 'continue';
    this.wizardBackSubscription ??= this.serviceWizardService.backEventEmitter.subscribe(() => this.onWizardBack());
    this.wizardContinueSubscription ??= this.serviceWizardService.continueEventEmitter.subscribe(() => this.onWizardContinue());
  }

  private async onWizardSetupRouteData(data: any) {
    const backwards = data['backwards'] === true;
    if (data['wizard'] !== true || !this.isWizardPendingCreation || backwards === this.wizardBackwards) return;
    // Switching between the forward and backwards setup steps in the reused component
    this.storePendingWizardSetup();
    this.wizardBackwards = backwards;
    this.resetWizardSetupState();
    this.activateWizardSetupStep();
    await this.initializeWizardDefaultSetup();
  }

  private storePendingWizardSetup() {
    if (!this.isWizardPendingCreation || !this.serviceWizardService.pendingQuickCreation) return;
    // The setup definition does not depend on the route: keep it so going back to a
    // previous step and returning does not lose the entered days of week / departures
    const pendingSetup = {
      setupDetail: this.setupDetail,
      departures: this.wizardDepartures,
      showAvailabilitiesView: this.showAvailabilitiesView,
    };
    if (this.wizardBackwards) this.serviceWizardService.pendingWizardBackwardsSetup = pendingSetup;
    else this.serviceWizardService.pendingWizardSetup = pendingSetup;
  }

  private resetWizardSetupState() {
    this.wizardDepartures = [];
    this.daysOfWeek = Object.fromEntries(Object.keys(this.daysOfWeek).map((day) => [day, []]));
    this.holyDays = Object.fromEntries(Object.keys(this.holyDays).map((day) => [day, []]));
    this.daysOfWeekCopy = structuredClone(this.daysOfWeek);
    this.holyDaysCopy = structuredClone(this.holyDays);
    this.changesDetected = false;
  }

  private get wizardRouteMaxTime(): number {
    const pendingQuickCreation = this.serviceWizardService.pendingQuickCreation;
    const route = this.wizardBackwards ? pendingQuickCreation?.backwardsRoute : pendingQuickCreation?.route;
    return route?.maxTime ?? 0;
  }

  get wizardDepartureRows(): any[] {
    const maxTimeMinutes = this.wizardRouteMaxTime;
    return this.wizardDepartures.map((departure) => ({
      ...departure,
      endDateTime: moment(departure.departureDateTime).add(maxTimeMinutes, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
    }));
  }

  onWizardSetupDateChange(dateField: 'fromDate' | 'toDate', event: any) {
    (this.setupDetail as any)[dateField] = event.target.value;
  }

  private get pathServiceId(): string | null {
    return this.activatedRoute.snapshot.params['id'] ?? null;
  }

  private get pathRouteId(): string | null {
    return this.activatedRoute.snapshot.params['routeId'] ?? null;
  }

  private get pathSetupId(): number | null {
    const setupIdParam = this.activatedRoute.snapshot.params['setupId'];
    return setupIdParam != null ? Number(setupIdParam) : null;
  }

  get usesPathStyleUrl(): boolean {
    return this.pathRouteId != null;
  }

  private buildSetupPath(setupId: number | undefined, availabilitiesView: boolean): any[] {
    const setupPath: any[] = ['/services', this.pathServiceId, 'routes', this.pathRouteId, 'setups'];
    if (setupId != null) setupPath.push(setupId);
    if (availabilitiesView) setupPath.push('availabilities');
    return setupPath;
  }

  private syncAvailabilitiesViewFromUrl() {
    if (this.isWizardPendingCreation) return;
    this.showAvailabilitiesView = this.router.url.split('?')[0].endsWith('/availabilities');
  }

  private async syncSelectedSetupFromUrl() {
    const pathSetupId = this.pathSetupId;
    if (!this.usesPathStyleUrl || pathSetupId == null || this.setups.length === 0) return;
    const setupIndex = this.setups.findIndex((setup) => setup.id === pathSetupId);
    if (setupIndex < 0 || setupIndex === this.selectedSetup) return;
    this.selectedSetup = setupIndex;
    this.loadingSetupDetail = true;
    try {
      this.setupDetail = await this.routeService.getRouteSetupsSchedule(Number(this.routeId), pathSetupId);
      this.getData();
    } finally {
      this.loadingSetupDetail = false;
    }
  }

  private reflectSelectedSetupInUrl(availabilitiesView: boolean = this.showAvailabilitiesView, replaceUrl = false) {
    const selectedSetupId = this.setups[this.selectedSetup]?.id;
    if (!this.usesPathStyleUrl || selectedSetupId == null) return;
    const queryParams: any = { ...this.activatedRoute.snapshot.queryParams };
    delete queryParams.availabilitiesPage;
    this.router.navigate(this.buildSetupPath(selectedSetupId, availabilitiesView), { queryParams, replaceUrl });
  }

  toggleAvailabilitiesView() {
    if (this.isWizardPendingCreation) {
      // Nothing is persisted yet: the toggle just switches between the local
      // departures view and the days-of-week grid
      this.showAvailabilitiesView = !this.showAvailabilitiesView;
      return;
    }
    this.reflectSelectedSetupInUrl(!this.showAvailabilitiesView);
  }

  private applyWizardPendingBreadcrumb() {
    const pendingQuickCreation = this.serviceWizardService.pendingQuickCreation;
    this.serviceName = pendingQuickCreation?.serviceInfo?.name || pendingQuickCreation?.serviceInfo?.tag || '';
    const pendingRoute = this.wizardBackwards ? pendingQuickCreation?.backwardsRoute : pendingQuickCreation?.route;
    this.routeName = pendingRoute?.name || '';
    this.updateBreadcrumb();
  }

  showWizardDeparturesModal() {
    this.seedDeparturesModalRows();
    if (!this.departuresModal) {
      this.departuresModal = new Modal(document.getElementById('routeDepartures'), {
        placement: 'center',
        closable: false,
        onHide: () => (this.departuresShowed = false),
        onShow: () => (this.departuresShowed = true),
      });
    }
    this.departuresModal.show();
  }

  private async initializeWizardDefaultSetup() {
    this.applyWizardPendingBreadcrumb();
    const restoredSetup = this.wizardBackwards
      ? this.serviceWizardService.pendingWizardBackwardsSetup
      : this.serviceWizardService.pendingWizardSetup;
    const forwardSetup = this.wizardBackwards ? this.serviceWizardService.pendingWizardSetup?.setupDetail : null;
    let defaultSetup: any;
    if (restoredSetup) {
      defaultSetup = restoredSetup.setupDetail;
      this.wizardDepartures = restoredSetup.departures ?? [];
    } else if (forwardSetup) {
      // The backwards setup starts from the forward attributes; its schedule is defined on its own
      defaultSetup = initialRouteSetupDetailCreate();
      defaultSetup.name = forwardSetup.name;
      defaultSetup.active = true;
      defaultSetup.fromDate = forwardSetup.fromDate;
      defaultSetup.toDate = forwardSetup.toDate;
      defaultSetup.config = structuredClone(forwardSetup.config);
      defaultSetup.route = { name: this.routeName } as any;
      defaultSetup.daysOfWeek = [];
      defaultSetup.holyDays = [];
    } else {
      defaultSetup = initialRouteSetupDetailCreate();
      defaultSetup.name = 'Default';
      defaultSetup.active = true;
      defaultSetup.fromDate = moment().format('YYYY-MM-DD') as any;
      defaultSetup.toDate = moment().add(1, 'year').format('YYYY-MM-DD') as any;
      defaultSetup.route = { name: this.routeName } as any;
      try {
        defaultSetup.config = await this.routeService.getDefaultSetupConfig() as any;
      } catch { /* the FE defaults stay as fallback */ }
    }
    this.setupDetail = defaultSetup;
    this.setups = [defaultSetup as any];
    this.setupData = [{
      id: 'wizard',
      value: defaultSetup,
      label: defaultSetup.name!,
      img: images.setup.enabled,
      alt: 'enabled',
    }];
    (this.setupDetail.daysOfWeek ?? []).forEach((dayOfWeekRow: any) => {
      this.daysOfWeek[dayOfWeekRow.dayOfWeek]?.push(dayOfWeekRow);
    });
    (this.setupDetail.holyDays ?? []).forEach((holyDayRow: any) => {
      this.holyDays[holyDayRow.holyDayType]?.push(holyDayRow);
    });
    Object.values(this.daysOfWeek).forEach((rows) => rows.sort((first, second) => first.startTime.localeCompare(second.startTime)));
    this.daysOfWeekCopy = structuredClone(this.daysOfWeek);
    this.holyDaysCopy = structuredClone(this.holyDays);
    this.showAvailabilitiesView = restoredSetup?.showAvailabilitiesView ?? this.isWizardDiscretionary;
    await this.loadDriversAndVehicles();
    if (restoredSetup) return;
    setTimeout(() => {
      if (this.isWizardDiscretionary) this.showWizardDeparturesModal();
      else this.createSchedule();
    });
  }

  private seedDeparturesModalRows() {
    const modalComponent = this.departuresModalComponent;
    if (!modalComponent || this.wizardDepartures.length === 0) return;
    const modalIsPristine = modalComponent.rows.length === 1 && !modalComponent.rows[0].date;
    if (!modalIsPristine) return;
    modalComponent.rows = this.wizardDepartures.map((departure: any) => ({
      date: String(departure.departureDateTime).slice(0, 10),
      startTime: String(departure.departureDateTime).slice(11, 16),
      vehicleId: String(departure.vehicleId),
      driverId: String(departure.driverId),
    }));
  }

  get wizardClientId(): number | undefined {
    return this.serviceWizardService.pendingQuickCreation?.serviceInfo?.clientId;
  }

  onDeparturesConfirmed(payload: any) {
    // Nothing is persisted here: the departures are shown in the main screen and the
    // topbar save commits everything together with any days of week defined
    this.wizardDepartures = payload.departures ?? [];
    this.departuresModal?.hide();
  }

  private buildWizardSetupPayload(setupDetail: any, departures: any[]): IServiceWizardSetupPayload | null {
    if (!setupDetail) return null;
    return {
      name: setupDetail.name ?? 'Default',
      fromDate: setupDetail.fromDate,
      toDate: setupDetail.toDate,
      config: setupDetail.config,
      daysOfWeek: (setupDetail.daysOfWeek ?? []).map((dayOfWeek: any) => ({
        dayOfWeek: dayOfWeek.dayOfWeek,
        startTime: dayOfWeek.startTime,
        endTime: dayOfWeek.endTime,
        driver: { id: dayOfWeek.driver?.id, name: dayOfWeek.driver?.name ?? '' },
        vehicle: { id: dayOfWeek.vehicle?.id, name: dayOfWeek.vehicle?.name ?? '' },
        comment: dayOfWeek.comment ?? null,
      })),
      holyDays: (setupDetail.holyDays ?? []).map((holyDay: any) => ({
        holyDayType: holyDay.holyDayType,
        startTime: holyDay.startTime,
        endTime: holyDay.endTime,
        driver: { id: holyDay.driver?.id, name: holyDay.driver?.name ?? '' },
        vehicle: { id: holyDay.vehicle?.id, name: holyDay.vehicle?.name ?? '' },
        comment: holyDay.comment ?? null,
      })),
      departures: (departures ?? []).map((departure: any) => ({
        departureDateTime: departure.departureDateTime,
        vehicleId: departure.vehicleId,
        driverId: departure.driverId,
      })),
    };
  }

  private async submitWizardSetupCreation() {
    this.creatingQuickService = true;
    this.creationPercentage = 0;
    this.creationDetail = '';
    const onProgress = (percentage: number, detail: string) => {
      this.creationPercentage = percentage;
      this.creationDetail = detail;
    };
    const currentSetup = this.buildWizardSetupPayload(this.setupDetail, this.wizardDepartures);
    let newService: IServiceInfo | null;
    if (this.wizardBackwards) {
      const forwardSetup = this.serviceWizardService.pendingWizardSetup;
      newService = await this.serviceWizardService.submitQuickCreation(
        this.buildWizardSetupPayload(forwardSetup?.setupDetail, forwardSetup?.departures ?? []),
        currentSetup,
        onProgress,
      );
    } else {
      newService = await this.serviceWizardService.submitQuickCreation(
        currentSetup,
        null,
        onProgress,
      );
    }
    this.creatingQuickService = false;
    if (newService) {
      this.changesDetected = false;
      this.returnToServicesList(newService);
    }
  }

  private returnToServicesList(service?: IServiceInfo) {
    this.serviceWizardService.stop();
    let path = '/services';
    if (service) path += `/${service.id}`;
    this.router.navigate([path], { replaceUrl: true, queryParams: { search: service?.name} });
  }

  buildBackUrls(): { services: string; service: string; route: string; availabilities: string } {
    const inherited = { ...this.activatedRoute.snapshot.queryParams };
    delete inherited['routeId'];
    delete inherited['setupId'];
    const query = buildQueryString(inherited);
    // The embedded availabilities page/size/search must not travel up to the services pages
    const upwardQuery = buildQueryString(inherited, ['availabilitiesPage', 'availabilitiesSize', 'availabilitiesSearch']);
    return {
      services: `/services${upwardQuery}`,
      service: this.serviceInfoId ? `/services/${this.serviceInfoId}/routes${upwardQuery}` : `/services${upwardQuery}`,
      route: this.serviceInfoId ? `/services/${this.serviceInfoId}/routes/${this.routeId}${upwardQuery}` : `/services${upwardQuery}`,
      availabilities: `/services/${this.serviceInfoId}/routes/${this.routeId}/availabilities${query}`,
    };
  }

  private updateBreadcrumb(): void {
    const { services, service, route } = this.buildBackUrls();
    this.backUrl = route;
    this.storageService.setBreadcrumb([
      { labelKey: 'sidebar.services', url: services },
      { label: this.serviceName, url: service },
      { label: this.routeName, url: route },
      { labelKey: 'setup.configuration' }
    ]);
  }

  showDuplicateSetupModal() {
    this.duplicateSetupModal = new Modal(document.getElementById('duplicateSetup'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.duplicateSetupShowed = false),
      onShow: () => (this.duplicateSetupShowed = true),
    });
    this.duplicateSetupModal.toggle();
  }

  async changeSetup(event: any) {
    this.selectedSetup = this.setupData.findIndex((setup: any) => setup.value === event.value);
    const setup = this.setupData.find((setup: any) => setup.value === event.value);
    if (this.usesPathStyleUrl) this.reflectSelectedSetupInUrl();
    this.loadingSetupDetail = true;
    try {
      this.setupDetail = await this.routeService.getRouteSetupsSchedule(setup.id, this.setups[this.selectedSetup].id!);
      this.getData();
    } finally {
      this.loadingSetupDetail = false;
    }
  }

  async getData() {
    await this.loadDriversAndVehicles();
    await this.getDaysOfWeekAndDrivers();
    await this.getHolyDays();
    this.getHolidayCalendars();
  }


  private colorForId(id: number): string {
    return this.colors[id % this.colors.length];
  }

  private async loadDriversAndVehicles() {
    if (this.isWizardPendingCreation) {
      await this.loadWizardClientDriversAndVehicles();
      return;
    }
    this.driversClientId = (this.setupDetail as any)?.client?.id;
  }

  private async loadWizardClientDriversAndVehicles() {
    // No route exists yet: drivers and vehicles are scoped to the client of the pending service
    const clientId = this.wizardClientId;
    this.driversClientId = clientId;
  }

  private async getDaysOfWeekAndDrivers() {
    const emptyWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    this.daysOfWeek = Object.fromEntries(emptyWeek.map(day => [day, []]));

    this.drivers = JSON.parse(await this.storageService.getDriversColors()) || {};
    this.vehicles = JSON.parse(await this.storageService.getVehiclesColors()) || {};

    for (const dayOfWeekObject of this.setupDetail.daysOfWeek) {
      const { dayOfWeek: day, driver, vehicle } = dayOfWeekObject;

      this.daysOfWeek[day].push(dayOfWeekObject);
      this.daysOfWeek[day].sort((a, b) => a.startTime.localeCompare(b.startTime));

      if (driver?.id && !this.drivers[driver.id]) this.drivers[driver.id] = this.colorForId(driver.id);
      if (vehicle?.id && !this.vehicles[vehicle.id]) this.vehicles[vehicle.id] = this.colorForId(vehicle.id);
    }

    this.daysOfWeekCopy = structuredClone(this.daysOfWeek);

    if (this.utilsService.compareObjects(this.drivers, {})) {
      await this.storageService.setDriversColors(JSON.stringify(this.drivers));
    }

    if (this.utilsService.compareObjects(this.vehicles, {})) {
      await this.storageService.setVehiclesColors(JSON.stringify(this.vehicles));
    }
  }

  private async getHolyDays() {
    const types = ['EVE', 'BANK'];
    this.holyDays = Object.fromEntries(types.map(type => [type, []]));

    this.drivers = JSON.parse(await this.storageService.getDriversColors()) || {};
    this.vehicles = JSON.parse(await this.storageService.getVehiclesColors()) || {};

    for (const holyDay of (this.setupDetail.holyDays ?? [])) {
      const { holyDayType, driver, vehicle } = holyDay;

      this.holyDays[holyDayType].push(holyDay);
      this.holyDays[holyDayType].sort((a, b) => a.startTime.localeCompare(b.startTime));

      if (driver?.id && !this.drivers[driver.id]) this.drivers[driver.id] = this.colorForId(driver.id);
      if (vehicle?.id && !this.vehicles[vehicle.id]) this.vehicles[vehicle.id] = this.colorForId(vehicle.id);
    }

    this.holyDaysCopy = structuredClone(this.holyDays);

    if (this.utilsService.compareObjects(this.drivers, {})) {
      await this.storageService.setDriversColors(JSON.stringify(this.drivers));
    }

    if (this.utilsService.compareObjects(this.vehicles, {})) {
      await this.storageService.setVehiclesColors(JSON.stringify(this.vehicles));
    }
  }

  private async ensureDriverVehicleColor(driverId?: number, vehicleId?: number) {
    if (driverId && !this.drivers[driverId]) {
      this.drivers[driverId] = this.colorForId(driverId);
      await this.storageService.setDriversColors(JSON.stringify(this.drivers));
    }

    if (vehicleId && !this.vehicles[vehicleId]) {
      this.vehicles[vehicleId] = this.colorForId(vehicleId);
      await this.storageService.setVehiclesColors(JSON.stringify(this.vehicles));
    }
  }

  private getHolidayCalendars() {
    this.holidayCalendars = this.setupDetail.holidayCalendars || [];
  }

  private timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }
  
  private normalizeTimeRange(start: string, end: string): [number, number] {
    const startMinutes = this.timeToMinutes(start);
    let endMinutes = this.timeToMinutes(end);
    if (endMinutes <= startMinutes) {
      endMinutes += 1440; // if pass midnigth
    }
    return [startMinutes, endMinutes];
  }
  
  private isOverlapping(start1: string, end1: string, start2: string, end2: string): boolean {
    const [s1, e1] = this.normalizeTimeRange(start1, end1);
    const [s2, e2] = this.normalizeTimeRange(start2, end2);
    return s1 < e2 && s2 < e1;
  }

  public overlaps(day: IRouteSetupDayOfWeek, index: number) {
    if (this.daysOfWeek[day.dayOfWeek][index+1]) {
      return !(this.isOverlapping(this.daysOfWeek[day.dayOfWeek][index].startTime, this.daysOfWeek[day.dayOfWeek][index].endTime,
                              this.daysOfWeek[day.dayOfWeek][index+1].startTime, this.daysOfWeek[day.dayOfWeek][index+1].endTime));
    }
    return true;
  }

  public matchesPrevious(day: IRouteSetupDayOfWeek, index: number) {
    if (this.daysOfWeek[day.dayOfWeek][index+1]) {
      return this.daysOfWeek[day.dayOfWeek][index].endTime === this.daysOfWeek[day.dayOfWeek][index+1].startTime;
    }
    return false;
  }

  public matchesNext(day: IRouteSetupDayOfWeek, index: number) {
    if (this.daysOfWeek[day.dayOfWeek][index-1]) {
      return this.daysOfWeek[day.dayOfWeek][index-1].endTime === this.daysOfWeek[day.dayOfWeek][index].startTime;
    }
    return false;
  }

  public overlapsHolyDay(holyDay: IRouteSetupHolyDay, index: number) {
    if (this.holyDays[holyDay.holyDayType][index+1]) {
      return !(this.isOverlapping(this.holyDays[holyDay.holyDayType][index].startTime, this.holyDays[holyDay.holyDayType][index].endTime,
                              this.holyDays[holyDay.holyDayType][index+1].startTime, this.holyDays[holyDay.holyDayType][index+1].endTime));
    }
    return true;
  }

  public matchesPreviousHolyDay(holyDay: IRouteSetupHolyDay, index: number) {
    if (this.holyDays[holyDay.holyDayType][index+1]) {
      return this.holyDays[holyDay.holyDayType][index].endTime === this.holyDays[holyDay.holyDayType][index+1].startTime;
    }
    return false;
  }

  public matchesNextHolyDay(holyDay: IRouteSetupHolyDay, index: number) {
    if (this.holyDays[holyDay.holyDayType][index-1]) {
      return this.holyDays[holyDay.holyDayType][index-1].endTime === this.holyDays[holyDay.holyDayType][index].startTime;
    }
    return false;
  }

  async showChangeStatus(event: {id: number, value: any}) {
    this.changeStatusSelected = event.value === 'activatedfemale';
    this.changeStatusIdSelected = event.id;
    this.changeStatusModal = new Modal(document.getElementById('changeStatus'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.changeStatusShowed = false),
      onShow: () => (this.changeStatusShowed = true),
    });
    this.changeStatusModal.toggle();
  }

  async changeStatusAction() {
    this.changingStatus = true;
    const isActive = this.changeStatusSelected;
    const action = isActive ? 'activateSetup' : 'deactivateSetup';
    const successKey = `setup.${action}.success`;
    const errorKey = `setup.${action}.error`;

    try {
      const res = await this.routeService[action](this.setupDetail.route.id!, this.setupDetail.id!) as any;
      this.setupDetail = res;
      this.utilsService.showNotification(images.notifications.check, successKey, NotificationTypes.SUCCESS);
      this.refreshSetupsData();
    } catch {
      this.utilsService.showNotification(images.notifications.warning, errorKey, NotificationTypes.DANGER);
    } finally {
      this.changeStatusModal.toggle();
      this.changingStatus = false;
    }
  }

  getModalTexts(type: string) {
    if (type === 'text') {
      return `setup.actions.${this.changeStatusSelected ? 'activated' : 'deactivated'}.description`;
    } else {
      return `setup.actions.${this.changeStatusSelected ? 'activated' : 'deactivated'}.title`;
    }
  }

  editAction() {
    this.editSetup = !this.editSetup;
  }

  resetSetupDetail(data: IRouteSetupDetail) {
    this.setupDetail = data;
  }

  closeDetails() {
    this.showDetails = false;
    this.newSetup = false;
    this.editSetup = false;
  }

  changeCardData(data: any, day: any) {
    if (data.type === 'driver' || data.type === 'vehicle') {
      if (data.value.id !== day[data.type].id) {
        day[data.type].id = data.value.id;
        day[data.type].name = data.value.label;
      }
    } else {
      if (data.value !== day[data.type]) day[data.type] = moment(data.value, 'HH:mm').format('HH:mm:ss');
    }
    this.checkChanges();
  }

  checkChanges() {
    const daysOfWeek = Object.keys(this.daysOfWeek);
    const holyDays = Object.keys(this.holyDays);
    this.differences = {};

    daysOfWeek.forEach((dayOfWeek: any) => {
      const diff = this.utilsService.getDifferencesGroupedByDay(this.daysOfWeek[dayOfWeek], this.daysOfWeekCopy[dayOfWeek]);
      this.differences[dayOfWeek] = diff;
    });

    holyDays.forEach((holyDay: any) => {
      const diff = this.utilsService.getDifferencesGroupedByDay(this.holyDays[holyDay], this.holyDaysCopy[holyDay]);
      this.differences[holyDay] = diff;
    });
    
    const daysChanged = daysOfWeek.some(dayOfWeek => {
      return !this.utilsService.compareArrayOfObjects(
        this.daysOfWeek[dayOfWeek],
        this.daysOfWeekCopy[dayOfWeek]
      );
    });

    const holyDaysChanged = holyDays.some(holyDay => {
      return !this.utilsService.compareArrayOfObjects(
        this.holyDays[holyDay],
        this.holyDaysCopy[holyDay]
      );
    });

    this.changesDetected = daysChanged || holyDaysChanged;
  }

  floatingButtonAction(option: any) {
    if (option === undefined) {
      this.editSchedules();
    } else {
      option.action();
    }
  }

  enableMultiselect() {
    this.multiselectEnabled = true;
    this.floatingButton = 'close';
    this.floatingButtonOptions = [];
    this.floatingButtonOptions.push({img: images.setup.edit, alt: 'edit', text: 'setup.editFields', action: () => this.editSchedules()});
    this.floatingButtonOptions.push({img: images.setup.delete, alt: 'delete', text: 'setup.deleteElements', action: () => this.showDeleteSchedulesModal()});
  }

  showDeleteSchedulesModal() {
    if (this.weekDaysChecked.length > 0) {
      this.deleteSchedulesModal = new Modal(document.getElementById('deleteSchedules'), {
        placement: 'center',
        closable: false,
        onHide: () => (this.deleteSchedulesShowed = false),
        onShow: () => (this.deleteSchedulesShowed = true),
      });
      this.deleteSchedulesModal.toggle();
    } else {
      this.utilsService.showNotification(images.notifications.info, 'setup.modal.deleteSchedule.selectSchedule', NotificationTypes.INFO);
    }
  }

  closeEditFloatingOptions() {
    this.multiselectEnabled = false;
    this.floatingButton = 'plus';
    this.floatingButtonOptions = [];
    //this.floatingButtonOptions.push({img: images.setup.export, alt: 'importExport', text: 'setup.importExport', action: undefined});
    this.floatingButtonOptions.push({img: images.setup.multicheck, alt: 'multiselect', text: 'setup.multiselect', action: () => this.enableMultiselect()});
    this.floatingButtonOptions.push({img: images.setup.addAvailabilities, alt: 'addAvailabilities', text: 'setup.addAvailabilities', action: () => this.createSchedule()});
  }

  async createSchedule() {
    this.createScheduleModal = new Modal(document.getElementById('createSchedule'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.createScheduleShowed = false),
      onShow: () => (this.createScheduleShowed = true),
    });
    await this.loadDriversAndVehicles();
    this.createScheduleModal.toggle();
  }
  
  editSchedules() {
    if (this.multiselectEnabled && this.weekDaysChecked.length > 0) {
      this.editScheduleComponent.resetForm();
      this.backingIdPlaceholder = this.orderedCheckedIds().join(', ');
      this.prefillEditScheduleModal();
      this.editScheduleModal = new Modal(document.getElementById('editSchedule'), {
        placement: 'center',
        closable: false,
        onHide: () => (this.editScheduleShowed = false),
        onShow: () => (this.editScheduleShowed = true),
      });
      this.editScheduleModal.toggle();
    } else {
      this.checkChanges();
      if (this.changesDetected) {
        if (this.isWizardPendingCreation) {
          // Wizard: nothing is persisted yet, the collected days of week go into the
          // quick-creation call instead of a setup update
          this.commitWizardSetupStep();
          return;
        }
        this.detectChangeTypes();
        this.confirmSetupUpdateModal = new Modal(document.getElementById('confirmSetupUpdate'), {
          placement: 'center',
          closable: false,
          onHide: () => (this.confirmSetupUpdateShowed = false),
          onShow: () => (this.confirmSetupUpdateShowed = true),
        });
        this.confirmSetupUpdateModal.show();
      } else {
        this.utilsService.showNotification(images.notifications.info, 'setup.modal.editSchedules.selectSchedule', NotificationTypes.INFO);
      }
    }
  }

  private orderedCheckedIds(): any[] {
    const ids: any[] = [];
    for (const day of this.days) {
      const isHolyDay = day.id === 'EVE' || day.id === 'BANK';
      const schedules = isHolyDay ? this.holyDays[day.id] : this.daysOfWeek[day.id];
      if (!schedules) continue;
      for (const schedule of schedules) {
        if (this.weekDaysChecked.includes(schedule.id)) ids.push(schedule.id);
      }
    }
    return ids;
  }

  private prefillEditScheduleModal() {
    const selected: any[] = [];
    Object.values(this.daysOfWeek).forEach((list: any[]) => {
      selected.push(...list.filter((s: any) => this.weekDaysChecked.includes(s.id)));
    });
    Object.values(this.holyDays).forEach((list: any[]) => {
      selected.push(...list.filter((s: any) => this.weekDaysChecked.includes(s.id)));
    });
    if (selected.length === 0) return;

    const editData = this.editScheduleComponent.editData;
    const commonValue = <T>(getter: (s: any) => T): T | undefined => {
      const first = getter(selected[0]);
      return selected.every(s => getter(s) === first) ? first : undefined;
    };

    const driverId = commonValue(s => s.driver?.id);
    if (driverId != null) {
      const driver = selected[0].driver;
      editData.driver = { id: driver.id, value: driver.id, label: driver.name ?? '' };
    }

    const vehicleId = commonValue(s => s.vehicle?.id);
    if (vehicleId != null) {
      const vehicle = selected[0].vehicle;
      editData.vehicle = { id: vehicle.id, value: vehicle.id, label: vehicle.name ?? '' };
    }

    const startTime = commonValue(s => s.startTime);
    if (startTime) editData.startTime = startTime as string;

    const endTime = commonValue(s => s.endTime);
    if (endTime) editData.endTime = endTime as string;

    const comment = commonValue(s => s.comment);
    if (comment != null) editData.comment = String(comment);

    const gtfsId = commonValue(s => s.gtfsId);
    if (gtfsId != null) editData.gtfsId = String(gtfsId);
    const extKey = commonValue(s => s.extKey);
    if (extKey != null) editData.extKey = String(extKey);
    const backingId = commonValue(s => s.backingId);
    if (backingId != null) editData.backingId = String(backingId);
  }

  detectChangeTypes() {
    this.hasScheduleUpdates = false;
    this.hasScheduleDeletes = false;

    const allDayKeys = [...Object.keys(this.daysOfWeek), ...Object.keys(this.holyDays)];

    for (const dayKey of allDayKeys) {
      const isHolyDay = dayKey === 'EVE' || dayKey === 'BANK';
      const current = isHolyDay ? this.holyDays[dayKey] : this.daysOfWeek[dayKey];
      const copy = isHolyDay ? this.holyDaysCopy[dayKey] : this.daysOfWeekCopy[dayKey];

      // Check for deletes: schedules that exist in copy but not in current
      const currentIds = new Set(current.map((s: any) => s.id).filter((id: any) => id !== undefined));
      const copyIds = copy.map((s: any) => s.id).filter((id: any) => id !== undefined);

      for (const copyId of copyIds) {
        if (!currentIds.has(copyId)) {
          this.hasScheduleDeletes = true;
          break;
        }
      }

      // Check for updates: schedules that exist in both but have different values
      for (const currentSchedule of current) {
        if (currentSchedule.id) {
          const copySchedule = copy.find((s: any) => s.id === currentSchedule.id);
          if (copySchedule) {
            if (currentSchedule.startTime !== copySchedule.startTime ||
                currentSchedule.endTime !== copySchedule.endTime ||
                currentSchedule.driver?.id !== copySchedule.driver?.id ||
                currentSchedule.vehicle?.id !== copySchedule.vehicle?.id ||
                currentSchedule.comment !== copySchedule.comment) {
              this.hasScheduleUpdates = true;
            }
          }
        }
      }

      if (this.hasScheduleUpdates && this.hasScheduleDeletes) break;
    }
  }

  onConfirmSetupUpdate(options: any) {
    this.updatingSetup = true;
    const updateData = this.pendingUpdateData || { type: 'update' };
    this.createUpdateSetup({
      ...updateData,
      options: {
        applyToAvailabilities: options.applyToAvailabilities,
        updateTrips: options.updateTrips,
        sendNotification: options.sendNotification,
        deleteOrphanedAvailabilities: options.deleteOrphanedAvailabilities,
        deleteComment: options.deleteComment,
        refund: options.refund,
        cancelRelated: options.cancelRelated,
        fullRefund: options.fullRefund
      }
    });
    this.pendingUpdateData = null;
  }

  storeOriginalDates() {
    this.originalSetupDates = {
      fromDate: this.setupDetail.fromDate,
      toDate: this.setupDetail.toDate,
      creationAdvancedDays: this.setupDetail.config?.creationAdvancedDays
    };
  }

  handleSetupDetailUpdate(data: any) {
    if (this.isWizardPendingCreation) {
      // The default setup only lives in the FE until quick creation: the fields are already
      // mutated in place by the detail form, so saving just leaves the edit mode
      this.editSetup = false;
      return;
    }
    if (data.type === 'create') {
      // For create, just proceed directly
      this.createUpdateSetup(data);
    } else {
      // For update, check for date changes and show modal
      this.pendingUpdateData = data;
      this.detectChangeTypes();
      this.checkDateChanges(data.value);
      this.confirmSetupUpdateModal = new Modal(document.getElementById('confirmSetupUpdate'), {
        placement: 'center',
        closable: false,
        onHide: () => (this.confirmSetupUpdateShowed = false),
        onShow: () => (this.confirmSetupUpdateShowed = true),
      });
      this.confirmSetupUpdateModal.show();
    }
  }

  checkDateChanges(newSetupDetail: any) {
    this.hasDateChanges = false;
    if (this.originalSetupDates) {
      const fromDateChanged = this.formatDate(newSetupDetail.fromDate) !== this.formatDate(this.originalSetupDates.fromDate);
      const toDateChanged = this.formatDate(newSetupDetail.toDate) !== this.formatDate(this.originalSetupDates.toDate);
      const daysAdvancedChanged = newSetupDetail.config?.creationAdvancedDays !== this.originalSetupDates.creationAdvancedDays;

      this.hasDateChanges = fromDateChanged || toDateChanged || daysAdvancedChanged;
    }
  }

  private formatDate(date: any): string {
    if (!date) return '';
    if (typeof date === 'string') return date.split('T')[0];
    if (date instanceof Date) return date.toISOString().split('T')[0];
    return '';
  }

  /**
   * Method to check a schedule from weekday
   * @param day Identifier
   */
  checkDay(day: number) {
    const index = this.weekDaysChecked.indexOf(day);
    index >= 0 ? this.weekDaysChecked.splice(index, 1) : this.weekDaysChecked.push(day);
  }

  /**
   * Method to know if schedule from weekday is checked or not
   * @param day Identifier
   * @returns boolean
   */
  checkIfIsChecked(day: number) {
    return this.weekDaysChecked.indexOf(day) > -1;
  }

  /**
   * Method to check or uncheck all schedules about day
   * @param event Event of checkbox
   * @param type Weekday
   */
  checkColumn(event: any, type: string) {
    const days = type !== 'EVE' && type !== 'BANK' ? this.daysOfWeek[type] : this.holyDays[type];
    days.forEach((day: any) => {
      if (!event.target.checked) {
        const index = this.weekDaysChecked.indexOf(day.id);
        this.weekDaysChecked.splice(index, 1);
      } else {
        this.weekDaysChecked.indexOf(day.id) === -1 && this.weekDaysChecked.push(day.id);
      }
    });
  }

  /**
   * Method to know if al schedules are selected
   * @param type Weekday
   * @returns boolean
   */
  checkIfAllIsChecked(type: string) {
    const allChecked: boolean[] = [];
    const days = type !== 'EVE' && type !== 'BANK' ? this.daysOfWeek[type] : this.holyDays[type];
    days.forEach((day) => {
      allChecked.push(this.weekDaysChecked.includes(day.id));
    });
    return allChecked.length > 0 ? allChecked.every((data: boolean) => data === true) : false;
  }

  async addSchedule(data: any) {
    await this.ensureDriverVehicleColor(data.driver.id, data.vehicle.id);

    // Generate time slots based on interval settings
    const timeSlots = this.generateTimeSlots(data);

    data.days.forEach((day: any) => {
      const dayId = typeof day === 'object' ? day.id : day;
      const isHolyDay = dayId === 'EVE' || dayId === 'BANK';
      const targetArray = !isHolyDay ? this.daysOfWeek[dayId] : this.holyDays[dayId];
      timeSlots.forEach(slot => {
        const newSchedule = {
          driver: {
            id: data.driver.id,
            name: data.driver.label
          },
          endTime: slot.endTime,
          startTime: slot.startTime,
          vehicle: {
            id: data.vehicle.id,
            name: data.vehicle.label
          },
          comment: data.message,
          ...(!isHolyDay ? { dayOfWeek: dayId } : { holyDayType: dayId })
        };

        targetArray.push(newSchedule);
        if (!isHolyDay) {
          this.setupDetail.daysOfWeek?.push(newSchedule as any);
        } else {
          this.setupDetail.holyDays?.push(newSchedule as any);
        }
      });

      targetArray.sort((a, b) => a.startTime.localeCompare(b.startTime));
    });

    this.checkChanges();
    this.createScheduleModal.hide();
  }

  async applyEditToSchedules(data: any) {
    await this.ensureDriverVehicleColor(data.driver?.id, data.vehicle?.id);

    // Find and update all selected schedules
    const allDays = [...Object.keys(this.daysOfWeek), ...Object.keys(this.holyDays)];

    allDays.forEach(dayKey => {
      const isHolyDay = dayKey === 'EVE' || dayKey === 'BANK';
      const schedules = isHolyDay ? this.holyDays[dayKey] : this.daysOfWeek[dayKey];

      schedules.forEach((schedule: any) => {
        // Check if this schedule is selected
        if (this.weekDaysChecked.includes(schedule.id)) {
          // Update only fields that have values
          if (data.driver) {
            schedule.driver = {
              id: data.driver.id,
              name: data.driver.label
            };
          }
          if (data.vehicle) {
            schedule.vehicle = {
              id: data.vehicle.id,
              name: data.vehicle.label
            };
          }
          if (data.startTime) {
            schedule.startTime = data.startTime;
          }
          if (data.endTime) {
            schedule.endTime = data.endTime;
          }
          if (data.comment !== undefined) {
            schedule.comment = data.comment;
          }
          if (data.gtfsId !== undefined && data.gtfsId !== '' && !isHolyDay) {
            schedule.gtfsId = data.gtfsId;
          }
          if (data.extKey !== undefined && data.extKey !== '') {
            schedule.extKey = data.extKey;
          }
          if (data.backingId !== undefined && data.backingId !== '') {
            schedule.backingId = Number(data.backingId);
          }
        }
      });

      // Re-sort by start time after modifications
      schedules.sort((a: any, b: any) => a.startTime.localeCompare(b.startTime));
    });

    // Clear selection, check for changes, and exit edit mode
    this.weekDaysChecked = [];
    this.checkChanges();
    this.editScheduleModal.hide();
    this.closeEditFloatingOptions();
  }

  deleteSelectedSchedules() {
    // Remove selected schedules from daysOfWeek
    Object.keys(this.daysOfWeek).forEach(dayKey => {
      this.daysOfWeek[dayKey] = this.daysOfWeek[dayKey].filter(
        (schedule: any) => !this.weekDaysChecked.includes(schedule.id)
      );
    });

    // Remove selected schedules from holyDays
    Object.keys(this.holyDays).forEach(dayKey => {
      this.holyDays[dayKey] = this.holyDays[dayKey].filter(
        (schedule: any) => !this.weekDaysChecked.includes(schedule.id)
      );
    });

    // Remove from setupDetail arrays
    this.setupDetail.daysOfWeek = this.setupDetail.daysOfWeek.filter(
      (schedule: any) => !this.weekDaysChecked.includes(schedule.id)
    );
    if (this.setupDetail.holyDays) {
      this.setupDetail.holyDays = this.setupDetail.holyDays.filter(
        (schedule: any) => !this.weekDaysChecked.includes(schedule.id)
      );
    }

    // Clear selection, check for changes, and exit edit mode
    this.weekDaysChecked = [];
    this.checkChanges();
    this.deleteSchedulesModal.hide();
    this.closeEditFloatingOptions();
  }

  private generateTimeSlots(data: any): { startTime: string; endTime: string }[] {
    const slots: { startTime: string; endTime: string }[] = [];
    const interval = parseInt(data.interval, 10);
    const intervalDuration = parseInt(data.intervalDuration, 10) || 0;

    // If no interval specified, return single slot with original times
    if (!interval || isNaN(interval)) {
      return [{ startTime: data.startTime, endTime: data.endTime }];
    }

    const maxEndMinutes = this.timeToMinutes(data.endTime);
    let currentStartMinutes = this.timeToMinutes(data.startTime);

    while (true) {
      const currentEndMinutes = currentStartMinutes + interval;

      // Stop if this slot's end time exceeds the maximum end time
      if (currentEndMinutes > maxEndMinutes) {
        break;
      }

      slots.push({
        startTime: this.minutesToTime(currentStartMinutes),
        endTime: this.minutesToTime(currentEndMinutes)
      });

      // Next slot starts after the break duration
      currentStartMinutes = currentEndMinutes + intervalDuration;
    }

    return slots;
  }

  private minutesToTime(minutes: number): string {
    const hours = Math.floor(minutes / 60) % 24;
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  async createUpdateSetup(data?: any) {
    const isUpdating = data.type === 'update';
    const action = isUpdating ? 'updateSetup' : 'createSetup';
    const successKey = `setup.${action}.success`;
    const errorKey = `setup.${action}.error`;

    try {
      const currentRouteId = this.setupDetail?.route?.id ?? Number(this.routeId);
      const res = isUpdating ?
        await this.routeService.updateSetup(currentRouteId, this.setupDetail.id!, this.setupDetail, data.options) as any :
        await this.routeService.createSetup(currentRouteId, this.newSetupObject);

      await this.loadSetups(currentRouteId);

      const index = this.setups.findIndex((setup: IRouteSetup) => setup.id === res.id);
      this.selectedSetup = index;

      this.setupDetail = res;
      await this.getData();

      this.newSetup = false;
      this.editSetup = false;
      this.storeOriginalDates();
      this.newSetupObject = initialRouteSetupDetailCreate(this.setupDetail);
      this.checkChanges();
      this.utilsService.showNotification(images.notifications.check, successKey, NotificationTypes.SUCCESS);
    } catch (error) {
      console.error('createUpdateSetup error:', error);
      this.utilsService.showNotification(images.notifications.warning, errorKey, NotificationTypes.DANGER);
    } finally {
      this.updatingSetup = false;
      this.confirmSetupUpdateModal?.hide();
    }
  }

  async duplicateSetup(data: { name: string; route: number }) {
    try {
      const currentSetup = this.setups[this.selectedSetup];
      await this.routeService.cloneSetup(Number(data.route), currentSetup.id!, data.name);

      await this.loadSetups(Number(this.routeId));
      this.selectedSetup = this.setups.findIndex((setup: IRouteSetup) => setup.id === currentSetup.id);

      this.utilsService.showNotification(images.notifications.check, 'setup.cloneSetup.success', NotificationTypes.SUCCESS);
    } catch {
      this.utilsService.showNotification(images.notifications.warning, 'setup.cloneSetup.error', NotificationTypes.DANGER);
    }
  }

  onNewSetup() {
    this.showDetails = true;
    this.newSetup = true;
  }

}
